<template>
  <div class="d-flex flex-row w-100 gap-2 payment-content ">
    <div class="d-flex flex-column w-25 left-nav">
      <div class="d-flex flex-row w-100 gap-2 py-2 px-2 justify-content-start align-items-center"
      @click="togglePayment('pay_now')"
      :class="selectedPayment === 'pay_now' ? 'payment-selected' : ''"
      >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#000"><path d="M864-696v432q0 29-21.15 50.5T792-192H168q-29 0-50.5-21.5T96-264v-432q0-29 21.5-50.5T168-768h624q29.7 0 50.85 21.5Q864-725 864-696Zm-696 72h624v-72H168v72Zm0 144v216h624v-216H168Zm0 216v-432 432Z"/></svg>
        </span>
        <span>Pay Now</span>
      </div>
      <div class="d-flex flex-row w-100 gap-2 py-2 px-2 justify-content-start align-items-center"
      @click="togglePayment('terms')"
      :class="selectedPayment === 'terms' ? 'payment-selected' : ''"
      >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" height="14px" viewBox="0 -960 960 960" width="14px" fill="#000000"><path d="M216-216h51l375-375-51-51-375 375v51Zm-72 72v-153l498-498q11-11 23.84-16 12.83-5 27-5 14.16 0 27.16 5t24 16l51 51q11 11 16 24t5 26.54q0 14.45-5.02 27.54T795-642L297-144H144Zm600-549-51-51 51 51Zm-127.95 76.95L591-642l51 51-25.95-25.05Z"/></svg>
        </span>
        <span>Request Terms</span>
      </div>
    </div>
    <div class="d-flex flex-column  w-75">
      <div class="d-flex flex-column w-100">
        <template v-if="selectedPayment === 'pay_now'">
          <div class="d-flex flex-column p-2 justify-content-between align-items-between gap-2 h-100">

            <span>Payment Options</span>

            <div class="d-flex flex-row w-100 gap-2">
              <div class="d-flex flex-row w-50 gap-2 align-items-start">
                <input type="radio" id="credit" name="payment" value="credit" v-model="selectedOption" class="mt-1">
                <span class="d-flex flex-col w-100">
                  <label for="credit" class="d-flex flex-col w-100">
                    <span>Credit Card</span>
                    <span class="fs-_6" >{{ processingFeeCC }}% processing fee</span>
                  </label>
                </span>
              </div>

              <div class="d-flex flex-row w-50 gap-2 align-items-start">
                <input type="radio" id="ach" name="payment" value="ach" v-model="selectedOption" class="mt-1">
                <span class="d-flex flex-col w-100">
                  <label for="ach" class="d-flex flex-col w-100">
                    <span>ACH</span>
                    <span class="fs-_6">{{ processingFeeACH }}% processing fee</span>
                  </label>
                </span>
              </div>
            </div>

            <div class="d-flex flex-column w-75 payment-details-container mt-4 mb-5">
              <div class="d-flex flex-row w-100 gap-2">
                <span>Subtotal:</span>
                <span>$</span>
                <span>{{ $filters.moneyFormat(grossTotal) }}</span>
              </div>
              <div class="d-flex flex-row w-100 gap-2">
                <span>{{ processingFee }}% Processing Fee:</span>
                <span>$</span>
                <span>{{ $filters.moneyFormat(processingFeeTotal) }}</span>
              </div>
              <div class="w-100 bg-dark" style="height: 2px;"></div>
              <div class="d-flex flex-row w-100 gap-2 mt-1"
              style="color: #000;">
                <span>Total Charge:</span>
                <span>$</span>
                <span>{{ $filters.moneyFormat(totalCharge) }}</span>
              </div>
            </div>



            <div class="d-flex w-100">
              <button
                  type="submit"
                  class="btn btn-outline-danger text-uppercase float-end w-100 AcceptUI"
                  data-billingAddressOptions='{"show":true, "required":false}'
                  :data-apiLoginID="authorizeLoginId"
                  :data-clientKey="authorizeClientKey"
                  data-acceptUIFormBtnTxt="Submit"
                  data-acceptUIFormHeaderTxt="Payment Options"
                  data-paymentOptions='{"showCreditCard": true, "showBankAccount": true}'
                  data-responseHandler="responseHandler"
                  id="paymentButton"
                  data-show="inline"
                  
              >
                  Pay Order
              </button>
            </div>
          </div>
          
        </template>

        <template v-if="selectedPayment === 'terms'" >
          <p>Request Payment Terms</p>
          <p>Looking to get terms with SilencerCo? Please fill out the form below and we'll review it and get back to you.</p>

        </template>
      </div>

    </div>
  </div>
</template>
<script>
import { computed, onMounted } from "vue";
import { useStore } from "vuex";
import axios from 'axios';

export default {

  props: ['grossTotal'],
  emits: ['closeModal', 'success'],
  setup() {
    const store = useStore();

    const processingFeeCC = computed(() => store.getters.getProcessingFeeCC);
    const processingFeeACH = computed(() => store.getters.getProcessingFeeACH);

    return {
      processingFeeCC,
      processingFeeACH,
      store,
    }
  },
  data() {
    return {
      selectedPayment: 'pay_now',
      selectedOption: 'credit',
      authorizeLoginId: process.env.MIX_AUTHORIZE_MERCHANT_LOGIN_ID,
      authorizeClientKey: process.env.MIX_AUTHORIZE_MERCHANT_CLIENT_KEY,
    }
  },
  computed: {
    processingFee() {
      if (this.selectedOption === 'credit') {
        return this.processingFeeCC;
      } else {
        return this.processingFeeACH;
      }
    },
    processingFeeTotal() {
      return this.grossTotal * (this.processingFee / 100);
    },
    totalCharge() {
      return this.grossTotal + this.processingFeeTotal;
    }
  },
  async mounted() {
    if (process.env.MIX_AUTHORIZE_IS_PRODUCTION == 1) {
        let authorizeScript = document.createElement("script");
        authorizeScript.setAttribute(
            "src",
            "https://js.authorize.net/v3/AcceptUI.js"
        );
        document.head.appendChild(authorizeScript);
    } else {
        let authorizeScript = document.createElement("script");
        authorizeScript.setAttribute(
            "src",
            "https://jstest.authorize.net/v3/AcceptUI.js"
        );
        document.head.appendChild(authorizeScript);
    }  

    await this.store.dispatch("getProcessingFeeCC");
    await this.store.dispatch("getProcessingFeeACH");

     // add event listener for authorize.net payments
     document
      .querySelector("#authorize_event_element")
      .addEventListener("paymentevent", (event) => {

          window.emitter.emit("changeLoaderStatus", true);
          console.log(event);
          if( !this.paymentInProgress ) {
              this.handlePayment(event.detail);
              this.paymentInProgress = true;
          }
      });
  },
  methods: {
    togglePayment(index) {
      this.selectedPayment = index;
    },  
    async handlePayment(data) {

      try {
        console.log(data);

        if( data?.messages?.message[0]?.code === "I_WC_01" ) {
          const response = await axios.post('api/payment/process', {
            price: this.totalCharge,
            dataDescriptor: data.opaqueData.dataDescriptor,
            dataValue: data.opaqueData.dataValue,
          });

          console.log(response);
          if( response.status === 200 && response.data.status === 'OK' ){
            this.$emit('success', response.data);
          }
        }

        window.emitter.emit("changeLoaderStatus", false);
      } catch( error ) {
        window.emitter.emit("changeLoaderStatus", false);
      }

    }, 
  }, 
}
</script>
<style>
.payment-details-container span {
  font-size: 12px;
}

.payment-details-container span:first-child {
  width: 50%;
}

.payment-details-container span:nth-child(3) {
  text-align: right;
  width: 50%;
}
.fs-_6 {
  font-size: 0.75rem;
}
.left-nav {
  background-color: #F7F6F6;
  border-bottom-left-radius: 0.5rem;
}

label {
  margin-bottom: 0 !important;
}

.left-nav span {
  cursor: pointer;
  color: #000;
  font-size: 14px;
}

.payment-selected {
  background-color: #fff;
}

.modal-body {
  padding: 0;
}

.payment-content {
  height: 300px;
}
</style>